<template>
  <header
    v-if="$route.name !== 'login' && $route.name !== '404'"
    class="header-wrapper"
  >
    <md-toolbar>
      <div class="header-bar">
        <div
          class="header-option header-option-left"
          @click="toggleSliderMenu"
          :class="{ 'option-disabled': userData.status }"
        >
          <md-button class="md-icon-button">
            <md-icon class="">
              <i class="pt pt-navigation-drawer"></i>
            </md-icon>
          </md-button>
        </div>
        <div
          class="header-option header-option-right"
          @click="toggleUserStatus"
        >
          <span style="visibility: hidden">{{
            `${onlineStatus} ${userData.status}`
          }}</span>
          <md-button
            class="md-icon-button"
            :class="{ online: userData.status }"
            :disabled="isSquadStackUser"
          >
            <md-icon class="">
              <i class="pt pt-user"></i>
            </md-icon>
          </md-button>
        </div>
      </div>
    </md-toolbar>
  </header>
</template>

<script type="text/javascript">
import router from "../scripts/router";
import EventBus from "../scripts/event-bus.js";
import UserService from "../scripts/services/userService.js";

export default {
  data() {
    return {
      userData: {},
      onlineStatus: 0,
    };
  },
  computed: {
    isSquadStackUser() {
      return (
        this.userData.roles && this.userData.roles.includes("SQUADSTACK_AGENT")
      );
    },
  },
  mounted() {
    let _this = this;
    _this.initialise();
  },
  methods: {
    initialise: function () {
      let _this = this;
      _this.userData = UserService.getUserData() || {};
      _this.attachEvents();
    },
    attachEvents: function () {
      let _this = this;
      EventBus.$on("updateUserData", () => {
        _this.userData = UserService.getUserData();
        _this.onlineStatus = _this.userData && _this.userData.status;
      });
    },
    toggleSliderMenu: function () {
      let _this = this;
      if (!_this.userData.status) {
        EventBus.$emit("toggleSliderMenu");
      }
    },
    pullCase: function () {
      return UserService.pullCase();
    },
    toggleUserStatus: function () {
      var _this = this;
      if (_this.isSquadStackUser) {
        return;
      }
      _this.userData = UserService.getUserData();
      if (_this.userData.status) {
        UserService.setUserStatus(0).then((response) => {
          _this.userData.status = 0;
          _this.onlineStatus = 0;
          UserService.goToDefaultScreen();
        });
      } else {
        UserService.setUserStatus(1).then((response) => {
          _this.userData.status = 1;
          _this.onlineStatus = 1;
          _this.pullCase();
        });
      }
    },
  },
};
</script>
